import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import CompanyApi from "../../../api/companyApi";
import { Company, Project } from "../../../types/Company";
import CompanyPrograms from "./CompanyPrograms/CompanyPrograms";
import Participants from "./Participants/Participants";
import s from "./SelectedCompany.module.css";

export type SelectedCompanyTab = "participants" | "projects";

type SelectedCompanyProps = {
  selectedCompanyData: Company;
  setSelectedCompany: Dispatch<SetStateAction<Company | null>>;
  setCompaniesData: Dispatch<SetStateAction<Company[] | null>>;
  initialActiveTab?: SelectedCompanyTab;
};

const SelectedCompany = ({
  selectedCompanyData,
  setSelectedCompany,
  setCompaniesData,
  initialActiveTab = "participants",
}: SelectedCompanyProps) => {
  const token = localStorage.getItem("token");
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] =
    useState<SelectedCompanyTab>(initialActiveTab);
  const [companyProjects, setCompanyProjects] = useState<Project[] | null>(
    null
  );
  const [actionLoaders, setActionLoaders] = useState({ loadProjects: false });

  useEffect(() => {
    setActiveTab(initialActiveTab);
  }, [initialActiveTab, selectedCompanyData._id]);

  const selectTabHandler = (tab: SelectedCompanyTab) => {
    setActiveTab(tab);

    const nextSearchParams = new URLSearchParams(searchParams);
    nextSearchParams.set("companyId", selectedCompanyData._id);

    if (tab === "projects") {
      nextSearchParams.set("tab", "projects");
    } else {
      nextSearchParams.delete("tab");
      nextSearchParams.delete("programId");
    }

    setSearchParams(nextSearchParams);
  };

  useEffect(() => {
    if (token) {
      const makeAsync = async () => {
        setActionLoaders((prev) => ({ ...prev, loadProjects: true }));
        const projectResponse = await CompanyApi.getCompanyProjects(
          token,
          selectedCompanyData._id
        );
        setActionLoaders((prev) => ({ ...prev, loadProjects: false }));
        if (projectResponse.status)
          setCompanyProjects(projectResponse.projects);
      };

      makeAsync();
    }
  }, [selectedCompanyData]);

  return (
    <div className={s.container}>
      <div className={s.tabsBlock}>
        <div
          className={
            activeTab === "participants" ? s.activeTab : s.notActiveTab
          }
          role="button"
          onClick={() => selectTabHandler("participants")}
        >
          <span>Participants</span>
          <span></span>
        </div>
        <div
          className={activeTab === "projects" ? s.activeTab : s.notActiveTab}
          role="button"
          onClick={() => selectTabHandler("projects")}
        >
          <span>Projects</span>
          <span></span>
        </div>
      </div>
      {activeTab === "participants" ? (
        <div>
          <Participants
            selectedCompany={selectedCompanyData}
            setSelectedCompany={setSelectedCompany}
            setCompaniesData={setCompaniesData}
            companyProjects={companyProjects}
          />
        </div>
      ) : (
        <CompanyPrograms
          selectedCompany={selectedCompanyData}
          companyProjects={companyProjects}
          projectsLoader={actionLoaders.loadProjects}
          setCompanyProjects={setCompanyProjects}
        />
      )}
    </div>
  );
};

export default SelectedCompany;
